<template>
  <div class="supplier-products-page">
    <PageHeader
      title="Bons de livraison"
      showBackIcon
      @back="$router.push({ name: 'NewReception' })" />
    <div class="page-wrapper">
      <el-button type="primary" @click="showDrawer = true">
        Ajouter un bon de livraison
      </el-button>
    </div>
    <div class="product-items-grid" v-loading="loading">
      <EmptyState v-if="!BDLs.length" />
      <BonDeLivraisonItem
        style="margin: 5px"
        v-for="bdl in BDLs"
        :key="bdl.id"
        :bonDeLivraison="bdl"
        @onClick="handleBonDeLivraisonChoosed(bdl)"
      />
    </div>
    <el-drawer
      :visible.sync="showDrawer"
      direction="btt"
      :with-header="false">
      <DrawerInput
        v-if="showDrawer"
        title="Ajouter un bon de livraison"
        label="Référence du bon de livraison"
        saveButtonText="Créer"
        @onCancel="showDrawer = false"
        @onValueSaved="handleNewBonDeLivraison"
        :defaultQuantity="0"
      />
    </el-drawer>
  </div>
</template>

<script>
import BonDeLivraisonItem from '@/views/pages/ChooseBonDeLivraisonPage/BonDeLivraisonItem.vue';
import BonDeLivraison from '@/entities/BonDeLivraison';
import PageHeader from '@/components/PageHeader/PageHeader.vue';
import EmptyState from '@/components/EmptyState.vue';
import services from 'services';
import DrawerInput from '@/components/DrawerInput.vue';

export default {
  components: {
    BonDeLivraisonItem,
    PageHeader,
    DrawerInput,
    EmptyState,
  },
  props: {
    supplierId: { type: String, required: true },
  },
  async mounted() {
    this.loading = true;
    await this.fetchData();
    this.loading = false;
  },
  data() {
    return {
      loading: false,
      BDLs: [],
      showDrawer: false,
    };
  },
  computed: {
    shopId() {
      return this.$store.getters['shopAuth/currentShopId'];
    },
  },
  methods: {
    async fetchData() {
      const BDLs = await services.bdlService
        .listBySupplierAndShopId(this.supplierId, this.shopId);
      this.BDLs = BDLs;
    },
    handleBonDeLivraisonChoosed(bdl) {
      this.$router.push({
        name: 'SupplierProducts',
        params: {
          supplierId: this.supplierId,
          bonDeLivraisonId: bdl.id,
        },
      });
    },
    async handleNewBonDeLivraison(ref) {
      const bonDeLivraison = new BonDeLivraison({
        id: ref,
        ref,
        shopId: this.shopId,
        supplierId: this.supplierId,
        status: BonDeLivraison.statusTypes.pending,
      });
      const bdl = await services.bdlService.upsertById(ref, bonDeLivraison);
      this.$router.push({
        name: 'SupplierProducts',
        params: {
          supplierId: this.supplierId,
          bonDeLivraisonId: bdl.id,
        },
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '../../../assets/css/main.styl';

.page-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100px;
  width: 100%;
}

.product-items-grid {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 20px;
}

.product-items-grid::after {
  content: '';
  flex: auto;
}

.supplier-products-page {
  width: 100%;
}
.supplier-products-card {
  width: 90%;
  margin-top: 0px;
  margin-bottom: 0px;
  overflow-x: hidden;
  border-radius: 0;
}

.shop-users-title {
  color: $primary-color;
  position: relative;
  font-size: 2.3em;
  font-weight: 600;
  display: inline;
}
.supplier-products-card__login-form {
}

</style>
